import { Pressable, StyleSheet, Text, View } from 'react-native';
import { router } from 'expo-router';
import { theme } from '@/constants/theme';
import { buildRuntimePath, type RuntimeBase } from '@/features/unified-learning/runtime/runtimeRoutes';

const BG = '#0B0B14';
const SURFACE = '#16142A';
const BORDER = '#2D2B50';
const TEXT = '#F0EFF8';
const TEXT_MED = '#9896B4';
const PRIMARY = theme.colors.primary;

type RuntimeSessionGuardProps = {
  runtimeBase: RuntimeBase;
  slug?: string;
  title?: string;
  description?: string;
};

export function RuntimeSessionGuard({
  runtimeBase,
  slug,
  title = 'צריך להתחיל ממסך המסלול',
  description = 'כדי לפתוח תרגול, סקירת טעויות או מצב מבחן צריך מזהה למידה פעיל. חזרו למסך המסלול והמשיכו משם.',
}: RuntimeSessionGuardProps) {
  return (
    <View style={s.center}>
      <View style={s.card}>
        <Text style={s.title}>{title}</Text>
        <Text style={s.description}>{description}</Text>
        <Pressable
          style={s.primaryBtn}
          onPress={() => {
            if (slug) {
              router.replace(buildRuntimePath(runtimeBase, slug) as any);
              return;
            }
            router.replace('/learn' as any);
          }}
          accessibilityRole="button"
        >
          <Text style={s.primaryBtnText}>{slug ? 'חזור לכניסה למסלול' : 'חזור ל-KURSI LEARN'}</Text>
        </Pressable>
      </View>
    </View>
  );
}

const s = StyleSheet.create({
  center: { flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: BG, padding: 20 },
  card: { maxWidth: 560, width: '100%', borderRadius: 14, borderWidth: 1, borderColor: BORDER, backgroundColor: SURFACE, padding: 18, gap: 10 },
  title: { color: TEXT, fontFamily: theme.fonts.bold, fontSize: 20, textAlign: 'right' },
  description: { color: TEXT_MED, fontFamily: theme.fonts.regular, fontSize: 16, textAlign: 'right', lineHeight: 24 },
  primaryBtn: { backgroundColor: PRIMARY, borderRadius: 12, alignItems: 'center', justifyContent: 'center', minHeight: 44, paddingVertical: 10, marginTop: 8 },
  primaryBtnText: { color: '#fff', fontFamily: theme.fonts.bold, fontSize: 16 },
});
